import { makeOnChangeHandler } from '@/components/common/input/helpers';
import { capitalize } from '@/lib/strings';
import type { UserStatus } from '@/store/users/types';
import { Select, SelectItem } from '@/components/ui';
import { useMemo } from 'react';

export function StatusSelect({
  status,
  onChange,
  className,
  allowAny = false,
}: {
  status: UserStatus;
  onChange?: (status: UserStatus) => void;
  className?: string;
  allowAny?: boolean;
}) {
  const changeHandler = makeOnChangeHandler({ singleTarget: onChange });
  const keys = useMemo(() => {
    const keys: UserStatus[] = [];
    if (allowAny) {
      keys.push('any');
    }

    keys.push('active', 'inactive', 'archived');

    return keys;
  }, [allowAny]);

  return (
    <Select
      defaultSelectedKeys={[status]}
      onChange={changeHandler}
      className={className}
    >
      {keys.map((key) => (
        <SelectItem key={key}>{capitalize(key)}</SelectItem>
      ))}
    </Select>
  );
}
